import React from "react";
import {
    createMuiTheme,
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    withStyles,
    Select,
    CircularProgress, Button
} from "@material-ui/core";
import { Formik } from "formik";
import * as Yup from "yup";
import moment from "moment";

import { DateTimePicker } from '@material-ui/pickers';
import { isSuperUser, hasPermission } from '../../sc-utilities';
import { ThemeProvider } from '@material-ui/styles';
import {getDateFormat} from "../../sc-utilities/date";

const styles = theme => ({
    root: {
        height: 'auto',
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    form: {
        width: '95%',
        margin: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    submit: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "50%",
        marginTop: "10px"
    },
    cancel: {
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        },
        width: "50%",
        marginTop: "10px"
    },
    text: {
        borderRadius: '1px',
        marginRight: 10,
        color: theme.palette.buttonText.default
    },
    divider: {
        margin: theme.spacing(1),
    },
    formControl: {
        width: '100%'
    },
});

const defaultMaterialThemeAdmin = createMuiTheme({
    palette: {
        primary: { 500: '#0C5A99' }
    }
});

const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: { 500: '#140D8A' }
    }
});

const PlanSaveForm = (props) => {
    const { classes, translations, handleSubmit, permissions, modalState, setModalState } = props;

    const versionOptions = [
        {value: 'editVersion', displayValue: translations['edit_current_version'] || 'Edit current version'},
        {value: 'createVersion', displayValue: translations['create_new_version'] || 'Create new version'}
    ]

    const initialValues = {
        VersionType: versionOptions[0].value,
        ActiveFrom: moment()
    }

    const formSettings = {
        Validation: Yup.object().shape({
            VersionType: Yup.string().required(),
            ActiveFrom: Yup.date().when("VersionType", {
                is: true,
                then: Yup.date().required()
            })
        }),
        ButtonSubmit: hasPermission(permissions, 'plan_update') ? {
            Title: translations["save"] || "SAVE"
        } : null,
        ButtonCancel: {
            Title: translations["cancel"] || "CANCEL",
        }
    };

    const closeModal = () => setModalState({open: false, values: {}});

    return (
        <div className={classes.root}>
            <Formik
                initialValues={initialValues}
                onSubmit={async (values, {setSubmitting}) => {
                    setSubmitting(true);
                    await handleSubmit({...modalState.values, ...values});
                }}
                validationSchema={formSettings.Validation}
            >
                {formikProps => {
                    const {
                        values,
                        handleSubmit,
                        handleChange,
                        handleBlur,
                        errors,
                        touched,
                        setFieldValue,
                        isSubmitting,
                        isValid,
                    } = formikProps;

                    return (
                        <form onSubmit={handleSubmit}>
                            <FormControl className={classes.formControl} margin={'dense'}>
                                <InputLabel shrink>{translations['select_version_option'] || 'Please select version option'}</InputLabel>
                                <Select name="VersionType" margin={'dense'} value={values?.VersionType || null}
                                        onChange={handleChange}>
                                    {(versionOptions ?? []).map(option => (
                                        <MenuItem key={option.value} value={option.value || null}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            {values?.VersionType === "createVersion" && <ThemeProvider theme={isSuperUser() ? defaultMaterialThemeAdmin : defaultMaterialTheme}>
                                <FormHelperText>{translations['activation_date'] || 'Activation date'}</FormHelperText>
                                <DateTimePicker
                                    name={'ActiveFrom'}
                                    onBlur={handleBlur}
                                    error={!!(errors.ActiveFrom && touched.ActiveFrom)}
                                    onChange={(date) =>
                                        setFieldValue("ActiveFrom", date)
                                    }
                                    ampm={false}
                                    minDate={moment()}
                                    value={values.ActiveFrom ?? null}
                                    margin={"dense"}
                                    onAccept={date => {
                                        setFieldValue("ActiveFrom", date)
                                    }}
                                    fullWidth={true}
                                    format={`${getDateFormat()} HH:mm:ss`}
                                />
                            </ThemeProvider>}

                            {formSettings.ButtonCancel ? (
                                <Button
                                    className={classes.cancel}
                                    variant="contained"
                                    color={formSettings.ButtonCancel.Color}
                                    onClick={closeModal}
                                >
                                    {formSettings.ButtonCancel.Title}
                                </Button>
                            ) : null}
                            {formSettings.ButtonSubmit ? (
                                <Button
                                    className={classes.submit}
                                    variant="contained"
                                    color={formSettings.ButtonSubmit.Color}
                                    type="submit"
                                    disabled={!isValid || isSubmitting}
                                >
                                    {isSubmitting ? <CircularProgress size={24}/> : formSettings.ButtonSubmit.Title}
                                </Button>
                            ) : null}
                        </form>
                    );
                }}
            </Formik>
        </div>
    )
}

export default withStyles(styles, { withTheme: true })(PlanSaveForm);
